export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-indent-less-d24c50161ef76cb8b1c8ef5b53d5aa71.svg";